import { LazyLoadImage } from 'react-lazy-load-image-component';

import './style.scss';
import Avatar from '../Avatar';
import { FOLLOW_STATUS, FOLLOW_TIER, s3Link } from '../../utils/constants';
import PStatistics from '../PStatistics';
import { Button, Paper } from '@mui/material';
import { useHistory } from 'react-router';
import currency from 'currency.js';
import React, { useEffect, useState, useRef } from 'react';
import CoverPic from '../CoverPic';
import moment from 'moment';
import { inFreeTiers } from '../../utils/helper';

const PUProfile = ({ user }) => {
    const [isPromoExpired, setIsPromoExpired] = useState(true);
    const history = useHistory();

    useEffect(() => {
        if (user.promo_start) {
            setIsPromoExpired(user.promo_duration
                == 0 ? false : moment.utc().local().isSameOrAfter(moment.utc(user.promo_start).add(user.promo_duration, 'hours').local()));
        } else {
            setIsPromoExpired(true);
        }
    }, [user]);

    const goToProfile = (e) => {
        history.push(`/${user.login}`);
    };

    return <div className='pu-profile'>
        <div className='pu-profile__cover'>
            <CoverPic user={user} />
        </div>
        <div className='pu-profile__details'>
            <div className='details__avatar'>
                <Avatar
                    pu={user}
                    story={false}
                    size='50'
                />
            </div>
            <div className='details__login'>
                <a
                    href='#'
                    onClick={goToProfile}
                >
                    @{user.login}
                </a>
            </div>
            <div className='details__stats'>
                <PStatistics user={user} />
            </div>
        </div>

        {
            // user.promo_start && user.promo_message && !user.followers_id && !isPromoExpired
            !isPromoExpired && [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(user.status)
                ? <div className='pu-profile__promo-message'>
                    <Paper
                        elevation={2}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: user.promo_message
                            }}
                        />
                    </Paper>
                </div>
                : null
        }

        <div className='pu-profile__actions'>
            {
                // Normal subscription Price
                !user.promo_start && (!user.followers_id || (user.followers_id > 0 && (user.status == FOLLOW_STATUS.UNSUBSCRIBED || user.status == null))) && !user.free_subscription
                    ? <button
                        className='btn theme-btn theme-btn-bordered btn-follow'
                        onClick={goToProfile}
                    >
                        SUBSCRIBE FOR {user ? currency(user.subscription_price).format({ precision: 2 }) : ''} PER MONTH
                    </button>
                    : null
            }

            {
                // Unsubscribed but not expired
                user.followers_id && user.followers_id > 0 && (user.status != null && user.status != FOLLOW_STATUS.UNSUBSCRIBED)
                    ? <Button
                        className={`${user.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW ? 'btn theme-btn theme-btn-bordered btn-follow' : ''}`}
                        onClick={goToProfile}
                        variant={`${user.status == FOLLOW_STATUS.ACTIVE ? 'outlined' : ''}`}
                        sx={{
                            borderRadius: '20px',
                            minWidth: '75%'
                        }}
                    >
                        {
                            user.status == FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW
                                ? `RE-SUBSCRIBE FOR ${user && user.promo_start
                                    ? currency(user.promo_price).format({ precision: 2 })
                                    : currency(user.subscription_price).format({ precision: 2 })
                                }`
                                : null
                        }

                        {
                            user.status == FOLLOW_STATUS.ACTIVE
                                ? (
                                    inFreeTiers(user.tier)
                                        ? 'FOLLOWING FOR FREE'
                                        : `SUBSCRIBED FOR ${currency(user.followers_amount).format({ precision: 2 })} PER MONTH`
                                )
                                : null
                        }
                    </Button>
                    : null
            }

            {
                user && user.promo_start && (user.status == FOLLOW_STATUS.UNSUBSCRIBED || user.status == null) && !user.free_subscription
                    ? (
                        user.promo_duration == 0
                            ? (
                                (!user.followers_id || user.followers_id > 0)
                                    ? <button
                                        className='btn theme-btn theme-btn-bordered btn-follow'
                                        onClick={goToProfile}
                                    >
                                        SUBSCRIBE FOR {currency(user.promo_price).format({ precision: 2 })} ON FIRST MONTH
                                    </button>
                                    : null
                            ) : (
                                // check if promo is expired
                                isPromoExpired
                                    ? <button
                                        className='btn theme-btn theme-btn-bordered btn-follow'
                                        onClick={goToProfile}
                                    >
                                        SUBSCRIBE FOR {user ? currency(user.subscription_price).format({ precision: 2 }) : ''} PER MONTH
                                    </button>
                                    : <button
                                        className='btn theme-btn theme-btn-bordered btn-follow'
                                        onClick={goToProfile}
                                    >
                                        SUBSCRIBE FOR {user ? currency(user.promo_price).format({ precision: 2 }) : ''} PER MONTH
                                    </button>
                            )
                    ) : null
            }

            {
                user.free_subscription && (user.followers_id <= 0 || (user.followers_id > 0 && user.status == FOLLOW_STATUS.UNSUBSCRIBED))
                    ? <button
                        className='btn theme-btn theme-btn-bordered btn-follow'
                        onClick={goToProfile}
                    >
                        FOLLOW FOR FREE
                    </button>
                    : null
            }
        </div>

    </div>;
};

export default React.memo(PUProfile);